import React from "react";
import Modulos from "../../components/Modulos";
import Select from "../../components/Select";
import {
  actionGetCentralByLoja,
  actionResetCentral,
  actionSelectCentral,
} from "../../features/central/slices";
import { actionGetModuloByCentral } from "../../features/modulo/slices";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { useAppSelector } from "../../hooks/useAppSelector";
import RegisterPontoMonitora from "./ModalRegister";
import "./styles.scss";
import BaseLayout from "../../components/Layout";
import factoryFields from "../../helpers/factory-fields";

const PageConfigPontoMonitoria = () => {
  const initialState = {
    openModal: false,
    entradaSelected: null,
  } as any;

  const [state, setState] = React.useState(initialState);

  const dispatch = useAppDispatch();

  const centraisByLoja = useAppSelector((state) => state.centraisByLoja);
  const lojaSelected = useAppSelector((state) => state.getLojas.lojaSelected);
  const lojas = useAppSelector((state) => state.getLojas.lojas);
  const [moduloSelected, setModuloSelected] = React.useState(null);

  const handleChangeSelectCentral = (ev: any) => {
    const val = ev.target.value;
    setModuloSelected(val);

    if (val && val !== "0") {
      dispatch(actionGetModuloByCentral(val));
      dispatch(actionSelectCentral(val));
    } else {
      setModuloSelected(null);
    }
  };

  const openModal = () => setState({ ...state, openModal: true });

  const closeModalRegister = () =>
    setState({ ...state, openModal: !state.openModal });

  React.useEffect(() => {
    dispatch(actionResetCentral());
    dispatch(actionGetCentralByLoja());
  }, [lojaSelected, dispatch]);

  return (
    <BaseLayout>
      <div className="container">
        <div className="row mb-40">
          <>
            {lojas.length > 0 && (
              <div className="container" style={{ marginBottom: "1.5rem" }}>
                <strong style={{ fontSize: "2.4rem", fontWeight: 700 }}>
                  {lojas.find((loja) => loja.id === Number(lojaSelected))?.nome}
                </strong>
              </div>
            )}
          </>

          <div className="col-sm-12 col-md-4">
            {lojaSelected ? (
              <Select
                options={factoryFields.centrais(centraisByLoja.data)}
                size="sm"
                label="Centrais"
                value={moduloSelected || ""}
                onChange={handleChangeSelectCentral}
              />
            ) : (
              <strong>Para iniciar selecione uma loja</strong>
            )}
          </div>
        </div>

        <Modulos cb={openModal} />

        {state.openModal && (
          <RegisterPontoMonitora close={closeModalRegister} />
        )}
      </div>
    </BaseLayout>
  );
};

export default PageConfigPontoMonitoria;
